import { useState } from "react";
import "./ProductPage.scss";
import ProductView from "./ProductView/ProductView";

function ProductPage({ cart, setCart }) {
    const [productQuality, setProductQuality] = useState(0);
    const [mainProductImage, setMainProductImage] = useState(0);
    const [onProductView, setOnProductView] = useState(false);

    // example product
    const { name, description, price, sale, images } = {
        name: "Fall Limited Edition Sneakers",
        description:
            "These low-profile sneakers are your perfect casual wear companion. Featuring a durable rubber outer sole, they'll withstand everything the weather can offer",
        price: 250,
        sale: 50,
        images: [
            "./images/image-product-1.jpg",
            "./images/image-product-2.jpg",
            "./images/image-product-3.jpg",
            "./images/image-product-4.jpg",
        ],
    };

    function handleMinusQuality() {
        productQuality && setProductQuality(productQuality - 1);
    }

    function handlePlusQuality() {
        setProductQuality(productQuality + 1);
    }

    function handleAddToCart() {
        if (!productQuality) return;
        const addToCart = {
            image: images[0],
            name: name,
            cost: (price * (100 - sale)) / 100,
            quality: productQuality,
        };
        setCart([...cart, addToCart]);
    }

    function handleOnProductView() {
        setOnProductView(true);
    }

    return (
        <div className="product-page">
            <div className="product-image">
                <div className="product-image__main">
                    <img
                        src={images.at(mainProductImage)}
                        onClick={handleOnProductView}
                    />
                </div>
                <div className="product-image__list">
                    {images.map((image, index) => (
                        <img
                            src={image}
                            onClick={() => {
                                setMainProductImage(index);
                            }}
                            key={index}
                        />
                    ))}
                </div>
            </div>
            <div className="product-detail">
                <div className="product-company">SNEAKER COMPANY</div>
                <div className="product-name">
                    <h1>{name}</h1>
                </div>
                <div className="product-description">{description}</div>
                <div className="product-price">
                    <div className="product-price__cost">
                        ${(price * (100 - sale)) / 100}
                    </div>
                    <div className="product-price__sale">{sale}%</div>
                    <div className="product-price__old-cost">${price}</div>
                </div>

                <div className="product-purchase">
                    <div className="product-quality">
                        <img
                            src="./images/icon-minus.svg"
                            onClick={handleMinusQuality}
                        />
                        <span>{productQuality}</span>
                        <img
                            src="./images/icon-plus.svg"
                            onClick={handlePlusQuality}
                        />
                    </div>
                    <div
                        className="product__cart-add"
                        onClick={handleAddToCart}
                    >
                        <img src="./images/icon-cart.svg" />
                        Add to cart
                    </div>
                </div>
            </div>

            {onProductView && (
                <ProductView
                    images={images}
                    setOnProductView={setOnProductView}
                />
            )}
        </div>
    );
}

export default ProductPage;
